import { Pipe, PipeTransform } from '@angular/core';
import { ShoppingCartItem } from '../../models/shopping';
import { extractShoppingCartItemPricedAttr } from '../../utils/cart';

@Pipe({
  name: 'shoppingCartItemPrice',
})
export class ShoppingCartItemPricePipe implements PipeTransform {
  transform(value: ShoppingCartItem, ...args: unknown[]): number {
    const priced_attr = extractShoppingCartItemPricedAttr(value);
    return priced_attr?.value?.price ?? 0;
  }
}
